export const GET_CHANGE_REQUESET_REASON_TYPES = {
  REQUEST: 'GET_CHANGE_REQUESET_REASON_TYPES_REQUEST',
  SUCCESS: 'GET_CHANGE_REQUESET_REASON_TYPES_SUCCESS',
  FAILURE: 'GET_CHANGE_REQUESET_REASON_TYPES_FAILURE'
};

export function getChangeRequestReasonTypes(payload) {
  return {
    payload,
    type: GET_CHANGE_REQUESET_REASON_TYPES.REQUEST
  };
}

export function getChangeRequestReasonTypesSuccess(payload) {
  return {
    payload,
    type: GET_CHANGE_REQUESET_REASON_TYPES.SUCCESS
  };
}

export function getChangeRequestReasonTypesFailure(payload) {
  return {
    payload,
    type: GET_CHANGE_REQUESET_REASON_TYPES.FAILURE
  };
}
